import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "graphs-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_BarGraph = _resolveComponent("BarGraph")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, { widthType: 'twoThirds' }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        "mode-edition": true,
        title: _ctx.widget.libelle,
        onDupliquer: _ctx.dupliquer,
        onFiltre: _ctx.filtre,
        onSuppression: _ctx.suppression
      }, null, 8, ["iconUrl", "title", "onDupliquer", "onFiltre", "onSuppression"]),
      _createElementVNode("div", null, [
        (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('multisites')), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
              return (_openBlock(), _createElementBlock("span", {
                key: site.id,
                class: "site-widget"
              }, [
                _createTextVNode(_toDisplayString(site.description) + " ", 1),
                (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PieChart, {
          colors: [_ctx.getColorEnCours(), _ctx.getColorARealiser(), _ctx.getColorRealiser()],
          height: '90%',
          isLoading: false,
          labels: [_ctx.$t('widgetPreventive.inProgress'), _ctx.$t('widgetPreventive.toDo'), _ctx.$t('widgetPreventive.done')],
          seriesValues: _ctx.donutSeries,
          showDataLabels: true,
          showLegend: true,
          title: _ctx.titlePie,
          width: '350px',
          class: "pie-chart-container chart-width",
          position: "right",
          onDataPointClicked: _ctx.naviguerVersRecherchePie
        }, null, 8, ["colors", "labels", "seriesValues", "title", "onDataPointClicked"]),
        _createVNode(_component_BarGraph, {
          categories: _ctx.getMonths(),
          colors: [_ctx.getColorEnCours(), _ctx.getColorARealiser(), _ctx.getColorRealiser()],
          customTooltip: _ctx.customTooltip,
          loading: false,
          seriesData: _ctx.barSeries,
          showLegend: false,
          class: "bar-graph-container chart-width2",
          onDataPointClicked: _ctx.naviguerVersRechercheBar
        }, null, 8, ["categories", "colors", "customTooltip", "seriesData", "onDataPointClicked"])
      ])
    ]),
    _: 1
  }))
}